<template>
	<div>
		<!-- 专家智库 -->
		<div class="expert">
			<Breadcrumb></Breadcrumb>
			<collect v-show="$route.meta.showFather" :parentmsg="type"></collect>
			<router-view />
		</div>
		<!-- <footers v-show="$route.fullPath == '/expert/wisdom'"></footers> -->
		<footers v-if="footersType == 0"></footers>
	</div>
</template>

<script>
	import Breadcrumb from '@/views/Breadcrumb.vue';
	import footers from '@/views/footers.vue';
	// import city from '@/components/city.json';
	import collect from '@/components/collect.vue';
	import {
		getExpert,
		getTypes
	} from '@/api/expert/api.js';
	export default {
		components: {
			Breadcrumb,
			footers,
			collect

		},
		data() {
			return {
				// provice: city.data,
				school: [],
				officl: [],
				goodat: [],
				money: [],
				isNo: [],
				expertList: [],
				currentPage4: 4,
				input: '',
				value: '',
				options: [{
					value: '选项3',
					label: '姓名'
				},{
					value: '选项1',
					label: '地区'
				}, {
					value: '选项2',
					label: '擅长领域'
				}],
				shows1: false,
				showAllSelected: false,
				curret: 0,
				//分页对象
				pageInline: {
					tableSizes: this.pageGroup.sizes, //显示条数分组
					tableTotal: 10, // 默认数据总数
				},
				type: '',
				footersType: 0,
			}
		},
		watch: {
			'$root.searchText'(val) {
				this.$router.push({
					name: 'wisdom',
					params: {
						selectType: 1,
						selectName: this.val,
						seachType: 1,
						footersType: 1,
					}
				})
			}
		},
		computed: {},

		created() {
			if(window.previousRoute!=null && ['expertDetail'].includes(window.previousRoute.name)) {
				this.footersType = window.localStorage.getItem("wisdom_foot_type")
				this.type = window.localStorage.getItem("wisdom_type")
			}else{
				this.footersType = this.$route.params.footersType || 0;
				this.type = this.$route.params.type;
			}
		},
		mounted() {

		},
		methods: {},
		activated() {
			
		},
		deactivated() {
			window.localStorage.setItem("wisdom_type", this.type)
			window.localStorage.setItem("wisdom_foot_type", this.footersType)
		}
	}
</script>

<style scoped>
	.expert {
		padding: 0 19%;
		/* margin-bottom: 100px; */
	}

	.boxshow {
		box-shadow: 0px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}

	.flex-1 {
		display: flex;
		align-items: center;
	}

	.experts {

		margin-top: 16px;

	}

	.experts p {
		font-size: 20px;
		color: #222222;
		font-family: font5;
		padding-left: 10px;
	}



	.check {
		/* width: 100%; */
		/* height: 352px; */
		background: #FAFAFA;
		border-radius: 4px 4px 4px 4px;
		color: #222222;
	}

	.check-1 {
		display: flex;
		/* align-items: center; */
		margin-bottom: 16px;
	}

	.check-1 p {
		padding: 4px 12px;
		font-size: 14px;
		font-family: font5;
		margin: 0 5px 8px 0;
	}

	.check-1-p {
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}

	.check-1-p p:first-child {
		/* color: #3377FF;
        background: #F0F5FF;
        border-radius: 8px 8px 8px 8px; */
	}

	.check-p {
		margin-right: 24px;
		min-width: 74px;
	}

	.jus-bet {
		justify-content: space-between;
	}

	.align-1 {
		align-items: center;
	}

	.shouqi {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		color: #666666;
	}

	.shouqi span {
		padding-right: 8px;
	}

	.search-2 {
		display: flex;
		border: 1px solid #EFEFEF;
		border-radius: 8px;
		margin: 24px;
	}

	.search-3 {
		display: flex;
		width: 100%
	}

	/deep/.elinput .el-input__inner {
		width: 100%;
		font-size: 14px;
		font-family: font3;
	}

	/deep/.elinput .el-input__inner::placeholder {
		color: #cccccc;
	}

	/deep/.el-select .el-input .el-select__caret {
		color: #222222;
	}

	/deep/.place .el-input__inner::placeholder {
		color: #222222;
	}

	/deep/.place {
		/* width: 80px; */
	}

	/deep/.el-input .el-input__inner {
		border-radius: 0;
		border: 0;
		background-color: rgba(0, 0, 0, 0);
		/* width: 80px; */
		font-size: 14px;

	}

	.col-22 {
		color: #222222;

	}

	.hed-img {
		width: 160px;
		height: 160px;
		padding-right: 16px;
	}

	.sex-img {
		width: 14px;
		height: 14px;
	}

	.online {
		font-size: 14px;
		color: #3377FF;
		padding: 8px 16px;
		background: #F0F5FF;
		white-space: nowrap;
		border-radius: 35px 35px 35px 35px;
		white-space: nowrap;
	}

	.mb-8 {
		margin-bottom: 8px;
	}

	.name-1 {
		font-size: 20px;
		font-family: font5;
		padding-right: 9px;
	}

	.name-2 {
		color: #999999;
		font-size: 14px;
		font-family: font3;
		white-space: nowrap;
		padding-right: 8px;
	}

	.name-3 {
		font-size: 14px;
		font-family: font3;
		font-weight: normal;
	}

	/deep/.el-pagination {
		text-align: center;
	}

	.footers {
		margin-top: 25px !important;
	}

	.selected {
		color: #3377FF;
		background: #F0F5FF;
		border-radius: 8px 8px 8px 8px;
	}

	.delAll {
		color: #222222;
	}

	.el-button--primary {
		border-radius: 0 8px 8px 0;
		background-color: #3377FF;
	}
</style>